import React from 'react'

import { useTranslation } from 'react-i18next'
import { connect, DataItem } from 'scrivito'

import { Button } from '@/Atomic/Molecules/Button'
import { Tooltip } from '@/Atomic/Molecules/Tooltip'
import { DataClassFollowUpActivityDrawer } from '@/Atomic/Widgets/DataClassDrawer/DataClass.FollowUpActivityDrawer'
import { useModalHandler } from '@/hooks/useModalHandler'

interface NewFollowUpActivityDrawerProps {
  originActivity: DataItem
  isDrawerButton?: boolean
  navigateOnCreated?: boolean
  onCreated?: (followUpActivity: DataItem) => void
}

export const NewFollowUpActivityDrawer: React.FC<NewFollowUpActivityDrawerProps> =
  connect(
    ({ originActivity, isDrawerButton, navigateOnCreated, onCreated }) => {
      const { isOpen, openModal, closeModal } = useModalHandler()

      const { t } = useTranslation()
      return (
        <>
          {isDrawerButton ? (
            <Button
              id="new-followup-activity-drawer"
              variant="icon"
              icon="activity-follow-up"
              onClick={openModal}
            />
          ) : (
            <Button
              title={t('common.create')}
              size="sm"
              iconSize="sm"
              iconColor="white"
              onClick={openModal}
              icon="add"
            />
          )}
          <DataClassFollowUpActivityDrawer
            originActivity={originActivity}
            isOpen={isOpen}
            close={closeModal}
            navigateOnCreated={navigateOnCreated}
            onCreated={onCreated}
          />
          <Tooltip
            anchorSelect="#new-followup-activity-drawer"
            content={t('tooltip.newFollowupActivity')}
            place="bottom"
          />
        </>
      )
    },
  )
